import React from "react";

const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      version="1.1"
      viewBox="0 0 35.876 35.876"
    >
      <g transform="translate(-1.5317 -1015.4)">
        <circle
          transform="matrix(-.5 -.86603 .86603 -.5 0 0)"
          cx="-904.64"
          cy="-499.82"
          r="16.205"
          fill="none"
          stroke="#000"
          strokeWidth="3.4773"
        />
        <rect
          x="18.079"
          y="1025.2"
          width="2.7808"
          height="16.392"
          rx=".20089"
          ry=".20089"
          fill="#000"
        />
        <rect
          transform="rotate(90)"
          x="1032"
          y="-27.666"
          width="2.7808"
          height="16.392"
          rx=".20089"
          ry=".20089"
          fill="#000"
        />
      </g>
    </svg>
  );
};
export default AddIcon;
